import { Button } from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import { setUser } from "../../store/actions/auth";
import { ReactComponent as Email } from "./assets/message.svg";
import CircularProgress from "@material-ui/core/CircularProgress";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";

class EmailAuth extends Component {
  state = {
    loginFailed: false,
    loading: false,
  };

  componentDidMount = () => {
    if (
      !this.props.settings.enable_social_auth ||
      !this.props.settings.enable_social_auth_staff
    ) {
      return;
    }
    const params = new URLSearchParams(window.location.search);
    const success = params.get("success");
    const token = params.get("auth_key");
    if (!success && !token) return;
    if (success != 1 || (success == 1 && !token)) {
      this.setState({ loginFailed: true });
      this.props.history.replace("/profile");
      return;
    }
    if (!this.props.auth.user) {
      this.props.setUser(token, this.props.history);
    }
    this.props.history.replace("/profile");
  };

  render() {
    const { auth, language, domain } = this.props;
    const { loginFailed } = this.state;
    return (
      <div>
        {loginFailed && (
          <p className="bold" style={{ color: "red" }}>
            {language == "english"
              ? "Something wrong happened. Please try again later"
              : "حدث خطأ ما. الرجاءالمحاولة لاحقا"}
          </p>
        )}
        {auth.user ? (
          <></>
        ) : (
          <ListItem
            style={{ height: 43 }}
            button
            divider
            onClick={() => {
              this.props.history.push("/profile/email-signin");
            }}
          >
            <ListItemIcon>
              <Email style={{ width: 20, height: 20 }} />
            </ListItemIcon>

            {this.state.loading ? (
              <span>
                <CircularProgress
                  style={{
                    width: 25,
                    height: 25,
                    color: "black",
                  }}
                />
              </span>
            ) : (
              <span>{language == "english" ? "Email" : "ايميل"}</span>
            )}
          </ListItem>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    auth: state.auth,
    settings: state.store.store.settings,
    branch: state.branch,
    domain: state.store.store.domain,
    pickup_only: state.cart.pickup_only_items,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (key, history) => dispatch(setUser(key, history)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(EmailAuth);
